import DesignTokens from '@tableau/design-tokens';
import { TabStyles } from '@tableau/widgets';

import { CommonStyles } from '~src/commonInfra/styles/CommonStyles';
import { applyColor }from '~src/style/ColorService';

import { cssClass } from '../../style';

const cssPrefix = 'BackgroundJobs';
export namespace BackgroundJobStyles {
  export const MastheadArea = cssClass(cssPrefix, 'masthead-area', {
    paddingTop: TabStyles.Spacing.LargeSpace,
    paddingRight: TabStyles.Spacing.ExtraLargeSpace,
    paddingLeft: TabStyles.Spacing.ExtraLargeSpace,
  });

  export const SummaryInfoContainer = cssClass(cssPrefix, 'summary-info-container', {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    $nest: {
      '&>div': {
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'center'
      }
    }
  });

  export const SummaryInfoButtonGroup = cssClass(cssPrefix, 'summary-info-button-group', {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    paddingTop: '4px',
    padding: '0',
    $nest: {
      '&>*': {
        paddingRight: TabStyles.Spacing.MediumSpace,
        paddingLeft: TabStyles.Spacing.SmallSpace,
      },
      '&>*:last-child': {
        paddingRight: 0,
      },
      '&>*:first-child': {
        paddingLeft: 0,
      }
    }
  });

  export const SummaryInfoItem: React.CSSProperties = {
    minWidth: 0, // 0 is the default
    color: applyColor(DesignTokens.color.font.default.secondary, CommonStyles.Colors.Grey102),
    fontSize: '14px',
    listStyleType: 'none',
  };
}
